import psychologyConsultationClient from '@/axiosClients/psychologyConsultationClient';

const getRecordedTalksCategories = () => {
    return psychologyConsultationClient.get('/recorded-talks/categories');
}

const getRecordedTalksByCategory = (categoryId) => {
    return psychologyConsultationClient.get(`/recorded-talks/category/${categoryId}`);
}

const getRecordedTalkDetails = (talkId) => {
    return psychologyConsultationClient.get(`/recorded-talks/${talkId}`);
}

const toggleFavoriteRecordedTalk = (data) => {
    return psychologyConsultationClient.post('/recorded-talks/toggle-favorite', data);
}

const markRecordedTalkAsViewed = (talkId) => {
    return psychologyConsultationClient.post(`/recorded-talks/${talkId}/mark-viewed`);
}

const getFavoriteRecordedTalks = () => {
    return psychologyConsultationClient.get('/recorded-talks/favorites');
}

const getLastUpcomingTalk = () => {
    return psychologyConsultationClient.get('/recorded-talks/last-upcoming-talk');
}

// Admin actions
const deleteRecordedTalk = (talkId) => {
    return psychologyConsultationClient.delete(`/recorded-talks/${talkId}`);
}

const getRecordedTalksTools = () => {
    return psychologyConsultationClient.get('/recorded-talks/tools');
}

const saveRecordedTalk = (formData) => {
    return psychologyConsultationClient.post('/recorded-talks/', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

const updateRecordedTalk = (talkId, formData) => {
    // Agregar el campo _method para simular PUT con POST
    formData.append('_method', 'PUT');
    
    return psychologyConsultationClient.post(`/recorded-talks/${talkId}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export default {
    getRecordedTalksCategories,
    getRecordedTalksByCategory,
    getRecordedTalkDetails,
    toggleFavoriteRecordedTalk,
    markRecordedTalkAsViewed,
    getFavoriteRecordedTalks,
    getLastUpcomingTalk,
    deleteRecordedTalk,
    getRecordedTalksTools,
    saveRecordedTalk,
    updateRecordedTalk
} 